if (!customElements.get('faq-accordion-section')) {
  class FaqAccordionSection extends HTMLElement {
    connectedCallback() {
      const navigationList = this.querySelector('[data-faq-accordion-nav]');
      const faqGroups = this.querySelectorAll('.faq-accordion__group');
      const searchInputElement = this.querySelector('.faq-accordion__content__search-input');

      if (navigationList && faqGroups.length) {
        navigationList.innerHTML = '';
        faqGroups.forEach((faqGroupElement) => {
          const groupTitleElement = faqGroupElement.querySelector('.faq-accordion__group-title');
          const groupTitle = groupTitleElement ? groupTitleElement.textContent.trim() : '';
          if (!groupTitle) return;

          const navigationItemElement = document.createElement('li');
          navigationItemElement.className = 'faq-accordion__link-item';

          const navigationLinkElement = document.createElement('a');
          navigationLinkElement.className = 'faq-accordion__link link--text';
          navigationLinkElement.href = `#${faqGroupElement.id}`;
          navigationLinkElement.textContent = groupTitle;

          navigationItemElement.appendChild(navigationLinkElement);
          navigationList.appendChild(navigationItemElement);
        });
      }

      if (searchInputElement) {
        searchInputElement.addEventListener('input', (event) => {
          const searchQuery = event.target.value || '';
          this.filterAccordions(searchQuery);
        });
      }
    }

    filterAccordions(query) {
      const normalizedSearchQuery = query.trim().toLowerCase();
      const faqGroups = this.querySelectorAll('.faq-accordion__group');

      if (!normalizedSearchQuery) {
        faqGroups.forEach((faqGroupElement) => {
          faqGroupElement.classList.remove('hidden');
          const accordionRows = faqGroupElement.querySelectorAll('.accordion');
          accordionRows.forEach((accordionRowElement) => {
            accordionRowElement.classList.remove('hidden');
          });
        });
        return;
      }

      faqGroups.forEach((faqGroupElement) => {
        const groupTitleElement = faqGroupElement.querySelector('.faq-accordion__group-title');
        const groupTitle = groupTitleElement ? groupTitleElement.textContent.trim().toLowerCase() : '';
        const groupMatchesSearch = groupTitle.includes(normalizedSearchQuery);

        const accordionRows = faqGroupElement.querySelectorAll('.accordion');
        let groupHasVisibleRow = false;

        accordionRows.forEach((accordionRowElement) => {
          const rowTitleElement = accordionRowElement.querySelector('.accordion__title');
          const rowTitle = rowTitleElement ? rowTitleElement.textContent.trim().toLowerCase() : '';
          const rowMatchesSearch = rowTitle.includes(normalizedSearchQuery) || groupMatchesSearch;

          if (rowMatchesSearch) {
            accordionRowElement.classList.remove('hidden');
            groupHasVisibleRow = true;
          } else {
            accordionRowElement.classList.add('hidden');
          }
        });

        if (groupMatchesSearch || groupHasVisibleRow) {
          faqGroupElement.classList.remove('hidden');
        } else {
          faqGroupElement.classList.add('hidden');
        }
      });
    }
  }

  customElements.define('faq-accordion-section', FaqAccordionSection);
}